import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { BodyMediumRegular, Button, HenryTips } from "@manifesthhqinc/ui-library";
import Spacing from "../../../layout/spacing";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";
import { FooterButtonDiv } from "../../../components/footer/styles";
import { STEP_DESTINATION_EXPLORE_IRA_OPTIONS } from "../../../class/transferDetails";
import { useEffect } from "react";

const MethodologyScreen = (props: UseExploreIRAOptionsType) => {
  const { goToScreen, setIsLoading } = props;

  useEffect(() => {
    setIsLoading(true);
    return () => setIsLoading(false);
  }, []);

  return (
    <TransitionWrapper>
      <ScrollableContainer name="methodology-screen">
        <Container>
          <Spacing vertical="20" />
          <HenryTips isBold className="justify-content--center">
            What’s our methodology?
          </HenryTips>
          <Spacing vertical="20" />
          <BodyMediumRegular>
            Manifest uses a number of factors to evaluate IRA providers. Through careful study of our users and their
            needs, we’ve chosen to recommend account providers that have a strong industry reputation, a fair and
            transparent fee structure, and a diverse asset selection. We also consider the quality of the account
            provider’s mobile application, web portal, research library, and customer service.
            <br />
            <br />
            <br />
            If you need additional assistance, we advise you to consult your accountant or financial advisor.
          </BodyMediumRegular>
        </Container>
      </ScrollableContainer>

      <Footer>
        <FooterButtonDiv>
          <Button size="large" onClick={() => goToScreen(STEP_DESTINATION_EXPLORE_IRA_OPTIONS)}>
            Go back
          </Button>
        </FooterButtonDiv>
      </Footer>
    </TransitionWrapper>
  );
};

export default MethodologyScreen;
